import spacetime from 'spacetime';
import { isString, isObject } from 'lodash';
import CustomPropTypeConstructor from './proptype';

// could be expanded to do pattern matching on the value
// e.g. new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}');
export const resemblesISODate = (testValue) => (isString(testValue) && testValue !== '') || isObject(testValue);

export const isDateTime = s => (resemblesISODate(s) ? spacetime(s).isValid() : false);

// this does allow 29:00
export const isTimeString = s => /[0-1]?[0-9]:[0-5][0-9]/.test(s);

export const TimeString = CustomPropTypeConstructor('TimeString', isTimeString);

// @todo This is NOT correct. DateTimeString will pass for a DateTime object.
export const DateTimeString = CustomPropTypeConstructor('DateTimeString', isDateTime);
